import {Component, Input, OnInit} from '@angular/core';
import {UserRightGroupUi} from '../../../interfaces/userRightGroupUi';

@Component({
  selector: 'qm-groups-of-right',
  templateUrl: './groups-of-right.component.html',
  styleUrls: ['./groups-of-right.component.css']
})
export class GroupsOfRightComponent implements OnInit {

  @Input() groupId: number;
  @Input() userRightsGroupUis: UserRightGroupUi[];

  constructor() {
  }

  async ngOnInit(): Promise<void> {
  }

}

